import { MAP_TYPES } from '@deck.gl/carto';
 
const LANE_CLOSURE_SAFETY_POINT_SOURCE_ID = 'laneClosureSafetyPointSource';
 
const source = {
  id: LANE_CLOSURE_SAFETY_POINT_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'lane_closure_safety_point',
};
 
export default source;
 